
import Loading from 'vux/src/components/loading/index.vue'

import { getDevice, getQueryString } from "@/config/utils";
import api from "@/api/index";
export default {
name: "App",
data() {
return {
isRouterAlive: true
};
},
methods: {},
components: {
Loading
},
computed: {
isLoading() {
return this.$store.state.isLoading;
}
},
created() {
if (!this.$store.state.custId && getQueryString("custId")) {
this.$store.state.custId = getQueryString("custId");
}
},
mounted() {
window.addEventListener("focusout", () => {
setTimeout(function() {
window.scrollTo(0, 0);
}, 1);

});

(function() {
if (
typeof WeixinJSBridge == "object" &&
typeof WeixinJSBridge.invoke == "function"
) {
handleFontSize();
} else {
if (document.addEventListener) {
document.addEventListener(
"WeixinJSBridgeReady",
handleFontSize,
false
);
} else if (document.attachEvent) {

document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
}
}
function handleFontSize() {

WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });

WeixinJSBridge.on("menu:setfont", function() {
WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
});
}
})();
},
computed: {
popStack() {
if (this.$route.name === "trusteeship") {
return "";
}
if (this.$store.state.direction === "forward") {
if (this.$route.name === "home") {
return "vux-pop-in";
} else {
return "vux-pop-in";
}
} else {
return "vux-pop-out";
}

},
displayStauts() {
return this.$store.state.maskView === "block" ? "show-mask" : "hide-mask";
}
},
methods: {}
};



// WEBPACK FOOTER //
// ./src/App.vue